"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Router;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const component_1 = __importDefault(require("@loadable/component"));
const PrivateRoute_1 = __importDefault(require("./components/PrivateRoute/PrivateRoute"));
function Router() {
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(PrivateRoute_1.default, { path: '/folders', exact: true, route: {
                component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/FoldersPage/FoldersHomePage')))),
            } }),
        react_1.default.createElement(PrivateRoute_1.default, { path: '/reports', exact: true, route: {
                component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/ReportsPage/ReportsHomePage')))),
            } }),
        react_1.default.createElement(PrivateRoute_1.default, { path: '/reports/:folderId', exact: false, route: {
                component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/EmbeddedReports/EmbedReportPage')))),
            } }),
        react_1.default.createElement(PrivateRoute_1.default, { path: '/folders/:folderId', exact: true, route: {
                component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/FoldersPage/SubFolderPage')))),
            } }),
        react_1.default.createElement(PrivateRoute_1.default, { path: '/recent', exact: false, route: {
                component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/RecentPage/RecentReportsPage')))),
            } }),
        react_1.default.createElement(PrivateRoute_1.default, { path: '/popular', exact: false, route: {
                component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/PopularPage/PopularReportsPage')))),
            } }),
        react_1.default.createElement(PrivateRoute_1.default, { path: '/favorite', exact: true, route: {
                component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/FavoritePage/FavoriteReportsPage')))),
            } }),
        react_1.default.createElement(PrivateRoute_1.default, { path: '/', exact: true, route: {
                component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/FoldersPage/FoldersHomePage')))),
            } }),
        react_1.default.createElement(react_router_dom_1.Route, { path: '/error', exact: true, component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/Errors/ErrorPage')))) }),
        react_1.default.createElement(react_router_dom_1.Route, { path: '/unauthorized', exact: true, component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/Errors/NotAuthorizedPage')))) }),
        react_1.default.createElement(react_router_dom_1.Route, { path: '/notfound', exact: true, component: (0, component_1.default)(() => Promise.resolve().then(() => __importStar(require('./components/Errors/NotFoundPage')))) })));
}
